import { useHistory, useLocation } from "react-router-dom";

import { useConfig } from "@jti/app-context/useConfig";
import { useSelector } from "@jti/store/reduxHooks";
import type { OrderState } from "@jti/store/slices/LEGACY__orderSlice";

export type UseFreeTrialType = {
  isFreeTrial: boolean;
  freeTrialId: string;
  freeTrialOrderState: OrderState;
};

export const useFreeTrial = (): UseFreeTrialType => {
  const { order, id } = useSelector((state) => state.freeTrialCart);
  const { pathname = "" } = useLocation();
  const history = useHistory();
  const config = useConfig();

  const isFreeTrial = pathname.startsWith("/trial/");
  if (isFreeTrial && config["trials-store-view"] === undefined) {
    history.push("/");
  }

  return {
    isFreeTrial,
    freeTrialId: id,
    freeTrialOrderState: order,
  };
};
